/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, DependencyList } from "react";

export const useDebounceEffect = (fn: () => void, waitTime: number, deps?: DependencyList) => {
  useEffect(() => {
    const t = setTimeout(() => {
      fn.apply(undefined);
    }, waitTime);

    return () => {
      clearTimeout(t);
    };
  }, deps);
};

// This is a custom React hook called useDebounceEffect. It is used to delay the execution of a function (fn) until a certain amount of time (waitTime) has passed after the last change in its dependencies (deps).